/* eslint-disable @typescript-eslint/indent */

/* Note: please be careful with indentation, we have the rule disabled because of
*  eslint not being able to properly indent js inside styled components
*/
// Core
import styled from 'styled-components';

// Component
import { EnableItemProps, EnableItemStatus } from './EnableItem.types';

export const Container = styled.div<Pick<EnableItemProps, 'enabled' | 'status'>>`
  align-items: center;
  background-color: ${({ theme }) => (theme.color.enableItem.backgroundColor)};
  border-radius: 4px;
  display: flex;
  height: 38px;
  padding: 8px 16px;

  svg {
    color: ${({ enabled, theme, status }) => {
      if (status === EnableItemStatus.neutral) {
        return theme.color.enableItem.neutralIconColor;
      }
      return enabled
        ? theme.color.enableItem.enableIconColor
        : theme.color.enableItem.indeterminateIconColor;
    }};
    height: 16px;
    width: 16px;
  };
`;

export const DescriptionContainer = styled.div`
  margin-left: 16px;
  max-width: 100%;
  overflow: hidden;
`;

export const Content = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  min-width: 0;
`;
